import { DialogUI } from '../Interface';
import { useTaskFeedback } from '../../hooks/useTaskFeedback';
import { TaskFeedbackPage } from './TaskFeedbackPage';

const TaskFeedbackDialog = ({ open, handleClose, data = {} }) => {
  const taskFeedbackState = useTaskFeedback();

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Feedback"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <TaskFeedbackPage
        dialog={{
          handleClose: handleClose,
          data,
        }}
        taskFeedbackState={taskFeedbackState}
      />
    </DialogUI>
  );
};

export default TaskFeedbackDialog;
